import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"

import { CompetitionDeadlinesFragment } from "lib/graphql"

dayjs.extend(utc)

const getDeadlineFieldName = (category: string): keyof CompetitionDeadlinesFragment => {
  const categoryToDeadlineMap: Record<string, keyof CompetitionDeadlinesFragment> = {
    Dans: "deadlineDans",
    DJ: "deadlineDJ",
    Expo: "deadlineExpo",
    Fashion: "deadlineFashion",
    Film: "deadlineFilm",
    Muziek: "deadlineMuziek",
    Taal: "deadlineTaal",
    Theater: "deadlineTheater",
  }
  
  return categoryToDeadlineMap[category] || "deadline"
}

export const hasExpired = (competition: CompetitionDeadlinesFragment, category?: string) => {
  if (category) {
    // only check the deadline for the given category and return true if it has passed
    const deadlineField = getDeadlineFieldName(category)
    const deadline = competition[deadlineField]
    return dayjs.utc(deadline).add(1, "day").isBefore(dayjs().endOf("day"))
  }

  const deadlines = {
    deadline: competition?.deadline,
    deadlineDJ: competition.deadlineDJ,
    deadlineDans: competition.deadlineDans,
    deadlineExpo: competition.deadlineExpo,
    deadlineFashion: competition.deadlineFashion,
    deadlineFilm: competition.deadlineFilm,
    deadlineMuziek: competition.deadlineMuziek,
    deadlineTaal: competition.deadlineTaal,
    deadlineTheater: competition.deadlineTheater,
  } as CompetitionDeadlinesFragment

  // Remove null/undefined deadlines
  Object.keys(deadlines).forEach((key) => {
    const castKey = key as keyof CompetitionDeadlinesFragment
    if (deadlines[castKey] === null || deadlines[castKey] === undefined) {
      delete deadlines[castKey]
    }
  })

  // Check if ALL deadlines have passed
  const allDeadlinesPassed = !Object.keys(deadlines).some((key) => {
    const deadline = deadlines[key as keyof CompetitionDeadlinesFragment]
    return dayjs.utc(deadline).add(1, "day").isAfter(dayjs().endOf("day"))
  })

  return allDeadlinesPassed
}

export const hasPassedFirstRound = (competition: CompetitionDeadlinesFragment) => {
  return dayjs.utc(competition.firstRoundDate).isBefore(dayjs().endOf("day"))
}

export const wasCreatedAfterDeadline = (competition: CompetitionDeadlinesFragment, act: { createdAt: string; category: string }) => {
  const deadlineField = getDeadlineFieldName(act.category)
  const deadline = competition[deadlineField]
  return dayjs(act.createdAt).isAfter(dayjs.utc(deadline))
}
